<dashboardnav>
  
    <cradua-ipstatus
        [ipstatuss]="ipstatuss$ | async"
        (ipstatus)="onSubmitIPStatus($event)"
        (deleteIPStatusEvent)="onDeleteIPStatus($event)"
        *ngIf="(isLoading$ | async ) === false"
        >
  </cradua-ipstatus>
  
    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoading$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
  